import { useEffect, useState } from 'react'

import NotesWithDrawer from './NotesWithDrawer'
import { useCreateNote } from '../hooks/useCreateNote'
import { getNotesQueryKey, useGetNotes } from '../hooks/useGetNotes'

interface MemberNotesProps {
  displayExistingNotes?: boolean
  memberId: string
  subjectId?: string
  subjectType?: string
}

const MemberNotes = ({
  displayExistingNotes = true,
  memberId,
  subjectId,
  subjectType,
}: MemberNotesProps) => {
  // NOTE: DO NOT include employerId in the fetch query, as this will include internal notes meant only for Thatch Admins.
  // The endpoint will only let you fetch one of memberId or employerId, not both.
  const {
    data: notes,
    error,
    isLoading,
  } = useGetNotes({ memberId, displayExistingNotes })
  const createNoteMutation = useCreateNote({ memberId, subjectType, subjectId })
  const notesQueryKey = getNotesQueryKey({ memberId })

  // Both of these may only become true (they don't get set back to false)
  const [isInitialLoadComplete, setIsInitialLoadComplete] = useState(false)
  const [isUnauthorized, setIsUnauthorized] = useState(false)

  useEffect(() => {
    const receivedData = Boolean(notes || error)
    if (receivedData) {
      setIsInitialLoadComplete(true)
    }
  }, [error, notes, setIsInitialLoadComplete])

  useEffect(() => {
    if (error?.status === 401) {
      setIsUnauthorized(true)
    }
  }, [error, setIsUnauthorized])

  return (
    <NotesWithDrawer
      error={error}
      isLoading={isLoading}
      createNoteMutation={createNoteMutation}
      displayExistingNotes={displayExistingNotes}
      notes={notes || []}
      queryKey={notesQueryKey}
      isInitialLoadComplete={isInitialLoadComplete}
      isUnauthorized={isUnauthorized}
    />
  )
}

export default MemberNotes
